import bankVerificationReducer from './reducers';
export { default as bankVerificationOperations } from './operations';
export { default as bankVerificationTypes } from './types';
export default bankVerificationReducer;